'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _css = require('antd/lib/button/style/css');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _css2 = require('antd/lib/message/style/css');

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _css3 = require('antd/lib/form/style/css');

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _product_desc_editor = require('./product_desc_editor');

var _product_desc_editor2 = _interopRequireDefault(_product_desc_editor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _form2.default.Item;


var BannerForm = _react2.default.createClass({
  displayName: 'BannerForm',
  onSubmit: function onSubmit(e) {
    var _this = this;

    e.preventDefault();
    this.props.form.validateFieldsAndScroll(function (err, values) {
      if (!err && values.banner) {
        var data = values.banner[values.banner.length - 1];
        if (!data.edit) {
          _message2.default.info('您还没有需要添加保存的图片');
          return;
        }
        if (!data.banner_id || !data.type || !data.default_order) {
          _message2.default.error('请填写完整');
          return;
        }
        var value = {
          image_id: data.banner_id,
          target: data.target,
          type: data.type,
          default_order: parseInt(data.default_order)
        };
        _this.props.onSubmit(value);
        _this.handleShowSubmit(false);
      } else {
        _message2.default.error(err);
      }
    });
  },
  getInitialState: function getInitialState() {
    return {
      showSubmit: false
    };
  },
  handleShowSubmit: function handleShowSubmit(show) {
    this.setState({
      showSubmit: show
    });
  },
  render: function render() {
    var banners = this.props.banners;
    var getFieldDecorator = this.props.form.getFieldDecorator;

    var formItemLayout = {
      labelCol: {
        span: 6
      },
      wrapperCol: {
        span: 14
      }
    };
    var tailFormItemLayout = {
      wrapperCol: {
        span: 14,
        offset: 6
      }
    };
    return _react2.default.createElement(
      _form2.default,
      { onSubmit: this.onSubmit },
      _react2.default.createElement(
        FormItem,
        _extends({}, formItemLayout, { label: '\u9996\u9875 Banner \u56FE', required: true }),
        getFieldDecorator('banner', {
          rules: [{ required: true, message: '请添加 Banner 图' }],
          initialValue: banners.items
        })(_react2.default.createElement(_product_desc_editor2.default, { imageSize: '160x160', type: 'bannerCreate',
          onShowSubmit: this.handleShowSubmit, handleDelete: this.props.handleDelete, productTypes: this.props.productTypes }))
      ),
      this.state.showSubmit ? _react2.default.createElement(
        FormItem,
        tailFormItemLayout,
        _react2.default.createElement(
          _button2.default,
          { type: 'primary', htmlType: 'submit', size: 'large' },
          '\u4FDD\u5B58'
        )
      ) : null
    );
  }
});

exports.default = _form2.default.create({
  mapPropsToFields: function mapPropsToFields(props) {
    return {
      banner: props.banners.items
    };
  }
})(BannerForm);


//////////////////
// WEBPACK FOOTER
// ./src/js/components/banner_form.js
// module id = 1568
// module chunks = 0